import * as React from "react";
import {
  Box,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Pagination,
  Stack,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";
import { useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import { isEmpty } from "lodash";
import {
  MATCHLIST,
  CHANGE_MATCH_STATUS,
  GET_SERIES_LIST,
  UPDATE_ALL_LIVE
} from "../constant/endpoint";
import { useStyles } from "../constant/constant";

// Sports constant
const SPORTS_TYPE = [
  { sport: 1, name: "Cricket" },
  { sport: 2, name: "Football" },
  { sport: 4, name: "Kabaddi" },
];

export default function SeriesMatches({ gst }) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [value, setValue] = React.useState("1");
  const [contextName, setContextName] = React.useState("Cricket");
  const [listData, setListData] = React.useState([]);
  const [defaultPage, setDefaultPage] = React.useState(1);
  const [totalPage, settotalPage] = React.useState(2);
  const [loading, setLoading] = React.useState(false);
  const [sport, setSport] = React.useState(1); // default Cricket

  const [seriesList, setSeriesList] = React.useState([]);
  const [selectedSeriesId, setSelectedSeriesId] = React.useState("");

  const fetchSeriesList = async (sport) => {
    try {
      console.log(sport);
      const res = await axios.get(`${GET_SERIES_LIST}?sport=${sport}`);
      if (res?.data?.status) {
        setSeriesList(res.data.data || []);
      }
    } catch (err) {
      console.error("Failed to fetch series list", err);
    }
  };

  const user = useSelector((state) => state.loginSlice);
  const userProfile = !isEmpty(user?.token)
    ? jwtDecode(user?.token)
    : { accessLevel: 0 };

  const handleChange = (event, newValue) => {
    const selected = SPORTS_TYPE.find((s) => s.sport.toString() === newValue);
    if (selected) {
      setContextName(selected.name);
      setSport(selected.sport);
      setValue(newValue);
      setDefaultPage(1);
      fetchSeriesList(selected.sport);
      getMatchList("", 1, selected.sport);
    }
  };

  const handlePagination = async (e, p) => {
    await getMatchList("", p, sport);
    setDefaultPage(p);
  };

  const getMatchList = async (
    status = "",
    pageNumber = 1,
    sportVal = 1,
    series_id
  ) => {
    setLoading(true);
    let url = `${MATCHLIST}&sport=${sportVal}`
      .replace(":status", "")
      .replace(":default", pageNumber);
    if (series_id) {
      url += `&series_id=${series_id}`;
    }
    console.log(series_id, url);
    const response = await axios.get(url);

    setLoading(false);
    if (response?.data?.status) {
      setListData(response?.data?.data.upcoming_match);
      settotalPage(response?.data?.data?.paginated_data?.totalPage);
    }
  };

  const updateLiveStatus = async (id, match_id, series_id, status) => {
    const data = {
      id,
      status: status ? 0 : 1,
      match_id,
      series_id,
    };
    await axios.post(`${CHANGE_MATCH_STATUS}`, data);
    await getMatchList("", defaultPage, sport);
  };

  const RedirectFun = (match_id, series_id, name) => {
    navigate(`/matchlist/${name}/${match_id}/${series_id}`);
  };

  React.useEffect(() => {
    getMatchList();
    fetchSeriesList(sport);
  }, []);

  const handleChange1 = (seriesId) => {
    setSelectedSeriesId(seriesId);
    setDefaultPage(1);
    getMatchList(gst ? "result" : "upcoming", 1, sport, seriesId);
  };

  const handleLive = async () => {
    try {
      const { data } = await axios.post(`${UPDATE_ALL_LIVE}?sport=${sport}`);
      if (data?.status) {
        Swal.fire("Success", "All today's matches set to live!", "success");
        getMatchList("", defaultPage, sport); // Refresh match list
      } else {
        Swal.fire("Error", data?.message || "Something went wrong", "error");
      }
    } catch (err) {
      console.error("Error while updating live matches:", err);
      Swal.fire("Error", "Failed to update live status", "error");
    }
  };

  return (
    <Box sx={{ width: "100%", typography: "body1", mt: "100px" }}>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            my: 2,
            width: "100%",
            maxWidth: 700,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <label style={{ fontWeight: 500 }}>Series:</label>
          <select
            value={selectedSeriesId}
            onChange={(e) => handleChange1(e.target.value)}
            style={{ flex: 1, padding: "8px", borderRadius: 4 }}
          >
            <option value="">All Series</option>
            {seriesList.map((series) => (
              <option key={series.series_id} value={series.series_id}>
                {series.series_name}
              </option>
            ))}
          </select>
          <Tooltip title="Mark all today's matches as live" arrow>
                <button
                style={{
                padding: "8px 12px",
                backgroundColor: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                }}
                onClick={handleLive}
            >
               Set Live
                </button>
          </Tooltip>
        </Box>
      </Box>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="sport tabs"
            variant="scrollable"
          >
            {SPORTS_TYPE.map((sportType) => (
              <Tab
                key={sportType.sport}
                label={sportType.name}
                value={sportType.sport.toString()}
              />
            ))}
          </TabList>
        </Box>
        <TabPanel value={value}>
          <TableContainer component={Paper} sx={{ my: 4 }}>
            <Table className={classes.table} sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow
                  sx={{
                    background: "linear-gradient(to right, #1976d2, #42a5f5)",
                  }}
                >
                  <TableCell align="center" sx={{ color: "#fff" }}>
                    Match Id
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Series Id
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#fff" }}>
                    Team vs Team
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Series
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Date
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Time
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Match Status
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Type
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#fff" }}>
                    Status
                  </TableCell>
                  {!gst && (
                    <TableCell align="center" sx={{ color: "#fff" }}>
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {listData.length > 0 ? (
                  listData.map((data) => (
                    <TableRow
                      key={data.match_id}
                      sx={{
                        backgroundColor:
                          data.prediction_match_status === 1
                            ? "#e8f5e9"
                            : "#FCE7E0",
                        "&:hover": {
                          backgroundColor: "#f1f8e9",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <TableCell align="center">{data.match_id}</TableCell>
                      <TableCell align="left">{data.series_id}</TableCell>
                      <TableCell align="center">
                        {data.local_team_name} Vs {data.visitor_team_name}
                      </TableCell>
                      <TableCell align="left">{data.series_name}</TableCell>
                      <TableCell align="left">
                        {moment(`${data.star_date} ${data.star_time}`).format(
                          "DD MMM YYYY"
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {moment(`${data.star_date} ${data.star_time}`).format(
                          "h:mm A"
                        )}
                      </TableCell>
                      <TableCell align="left">{data.match_status}</TableCell>
                      <TableCell align="left">{data.type}</TableCell>
                      <TableCell align="left">
                        <span
                          style={{
                            padding: "4px 8px",
                            borderRadius: "8px",
                            color: "#fff",
                            backgroundColor:
                              data.prediction_match_status === 1
                                ? "#2e7d32"
                                : "#c62828",
                          }}
                        >
                          {data.prediction_match_status === 1 ? "Active" : "InActive"}
                        </span>
                      </TableCell>
                     {data.match_status == "Not Started" ? <TableCell
                        align="center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Tooltip
                          title={
                            data.prediction_match_status === 1
                              ? "Turn Off Live"
                              : "Turn On Live"
                          }
                        >
                          <Switch
                            checked={data.prediction_match_status === 1}
                            onChange={() =>
                              updateLiveStatus(
                                data._id,
                                data.match_id,
                                data.series_id,
                                data.prediction_match_status
                              )
                            }
                            color="success"
                          />
                        </Tooltip>
                      </TableCell>:""}
                    </TableRow>
                  ))
                ) : loading ? (
                  <Box
                    sx={{
                      position: "fixed",
                      top: 0,
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 9999,
                      paddingTop: "30%",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <h3 style={{ textAlign: "center" }}>No Data Found</h3>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack spacing={2}>
            {listData.length > 0 && (
              <Pagination
                count={totalPage}
                page={defaultPage}
                color="primary"
                onChange={handlePagination}
              />
            )}
          </Stack>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
